module.exports = __webpack_public_path__ + "static/media/sara-2.29101ff5.png";